import React from 'react';
import { Reveal } from '../ui/Reveal';

const steps = [
  { num: "01", title: "Consultation", desc: "Initial discussion to understand the scope and timeline." },
  { num: "02", title: "Data Collection", desc: "Gathering property details and analyzing market trends." },
  { num: "03", title: "Inspection", desc: "On-site evaluation by certified appraisers." },
  { num: "04", title: "Reporting", desc: "Compiling a defensible, comprehensive report." }
];

const Process = () => {
  return (
    <section id="process" className="py-24 bg-charcoal-900 border-t border-white/5 relative">
      <div className="container mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-16">
            <h2 className="text-gold-500 text-sm font-bold tracking-widest uppercase mb-2">How We Work</h2>
            <h3 className="text-3xl font-bold text-white mb-6">Our Streamlined Process</h3>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-4 gap-8">
          {steps.map((step, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="border border-white/10 p-6 bg-charcoal-850 hover:border-gold-500 transition-colors h-full">
                <div className="text-gold-500 font-display text-4xl font-bold mb-4 opacity-50">
                  {step.num}
                </div>
                <h4 className="text-lg font-bold text-white mb-2">{step.title}</h4>
                <p className="text-gray-400 text-sm">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;